import { render, staticRenderFns } from "./BulkInvoiceModalComponent.vue?vue&type=template&id=387fd635&"
import script from "./BulkInvoiceModalComponent.vue?vue&type=script&lang=js&"
export * from "./BulkInvoiceModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports